/*
 * @Author: zhushitao
 * @Date: 2021-07-21 15:14:17
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-11-04 10:54:27
 * @Description:
 */
export { ENV, imCloudConfig, apiOrigin } from './constants/net';

export { MESSAGE_ALL_TYPE, DialogCreateResultType } from './constants/index';
export { Region, Lang } from './constants/lang';
export { EventCode } from './constants/eventCode';
export {
  DIALOG_STATUS,
  DIALOG_TYPE,
  SEND_TYPE,
  TRANSFER_TYPE,
  USER_STATUS,
} from './constants/status';
export { ERROR_TYPE } from './constants/error';
export type {
  IFileMessageContent,
  IJarvisCardInfo,
  IMessageContent,
} from './lib/sendMessage';
export { TRACE_TYPE } from './constants/trace';
export { LinkchatEvent } from './constants/event';
export { USER_IDENTITY } from './constants/identity';
export { onErrorSubject } from './lib/subject';
export { userAuthAxios, EContactType } from './utils/userAuth/userAuthAxios';

export type {
  CombineMessageType,
  ILinkchatProps,
  IAjaxDetail,
  AppContextType,
} from './lib/type';
export * from '@byted/im-web-sdk';
import Channel from './core/ws';
import Linkchat from './lib/index';
import JarvisPlugin from './plugins/jarvis';
import { I18n, initI18N, initI18NLazy } from './utils/lang';

export { JarvisPlugin, Channel, Linkchat, I18n, initI18N, initI18NLazy };
export default Linkchat;
